/**
 * Упрощённый текст для превью в списках: убирает типичный markdown-синтаксис,
 * чтобы не показывать сырые `##`, `**`, блоки цитат.
 */
export function markdownPlainPreview(source: string, maxLength = 320): string {
  let s = source.replace(/\r\n/g, '\n');

  s = s.replace(/^#{1,6}\s+/gm, '');
  s = s.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '$1');
  s = s.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1');
  s = s.replace(/^\s*[-*+]\s+/gm, '• ');
  s = s.replace(/^\s*\d+\.\s+/gm, '');
  s = s.replace(/\*\*([^*]+)\*\*/g, '$1');
  s = s.replace(/\*([^*]+)\*/g, '$1');
  s = s.replace(/^>\s?/gm, '');
  s = s.replace(/```[\s\S]*?```/g, ' ');
  s = s.replace(/`([^`]+)`/g, '$1');
  s = s.replace(/<\/?[^>]+>/g, ' ');
  s = s.replace(/\n+/g, ' ');

  return s.replace(/\s+/g, ' ').trim().slice(0, maxLength);
}
